/**
 * Renders the curated business-status banner / dot.
 * Source of truth lives on the backend (`BUSINESS_STATUS_CODES`); the frontend
 * just maps codes to displayable templates. Keep this list aligned.
 */
// Source of truth for templates (what shows on the profile banner)
const TEMPLATES = {
  none: "",
  accepting: "🟢 Accepting new clients",
  booking_1_2_weeks: "🟡 Booking 1–2 weeks out",
  booking_3_4_weeks: "🟡 Booking 3–4 weeks out",
  closed: "🔴 Not accepting new clients",
  closed_until: "🔴 Not accepting new clients until {return_date}",
  free_estimates: "⭐ Free estimates available",
  family_owned: "🏠 Family owned business",
  book_via_website: "📅 Book through my website",
  custom: "{custom_text}",
};

// Friendly labels for the dashboard dropdown (no template tokens)
const FRIENDLY = {
  accepting: "🟢 Accepting new clients",
  booking_1_2_weeks: "🟡 Booking 1–2 weeks out",
  booking_3_4_weeks: "🟡 Booking 3–4 weeks out",
  closed: "🔴 Not accepting new clients",
  closed_until: "🔴 Closed — until a date you set",
  free_estimates: "⭐ Free estimates available",
  family_owned: "🏠 Family owned business",
  book_via_website: "📅 Book through my website",
  custom: "✏️ Custom message",
};

const DOT_COLOR = {
  accepting: "#22C55E",
  booking_1_2_weeks: "#F59E0B",
  booking_3_4_weeks: "#F59E0B",
  closed: "#EF4444",
  closed_until: "#EF4444",
  free_estimates: "#2E6B57",
  family_owned: "#C79B6B",
  book_via_website: "#3B82F6",
  custom: "#2E6B57",
};

export function statusText(status) {
  if (!status || !status.code || status.code === "none") return "";
  const tpl = TEMPLATES[status.code] || "";
  return tpl
    .replace("{return_date}", status.return_date || "—")
    .replace("{custom_text}", (status.custom_text || "").trim());
}

export function statusDotColor(status) {
  if (!status || !status.code || status.code === "none") return null;
  return DOT_COLOR[status.code] || "#2E6B57";
}

export const STATUS_OPTIONS = Object.entries(FRIENDLY).map(([code, label]) => ({ code, label }));
